// Link to the same color scheme in Figma: https://www.figma.com/file/SbamdS9x3EglDShf3f3f34/Checkbox-Design-System?node-id=828%3A25508
export const COLOURS_AA = {
  primary: {
    BtnPrimaryHover: '#17ba86',
    BtnPrimaryDefault: '#15a779',
    BtnPrimaryClick: '#12956b',
    PrimaryCTADefault: '#15A779',
  },
  secondary: {
    BtnSecondaryHover: '#26354a',
    BtnSecondaryDefault: '#0e1f36',
    BtnSecondaryClick: '#0b192b',
  },
  special: {
    BtnSpecialHover: '#D5F2E8',
    BtnSpecialDefault: '#C5EDE0',
    BtnSpecialClick: '#BEEBDC',
  },
  delete: {
    BtnDeleteHover: '#D92D2D',
    BtnDeleteDefault: '#CA1919',
    RedDeleteClick: '#A81313',
  },
  disabled: {
    Disabled100: '#FBFBFB',
    Disabled150: '#F2F2F2',
    Disabled200: '#E3E3E3',
    Disabled300: '#DADADA',
    Disabled400: '#D1D1D1',
    Disabled500: '#B7B7B7',
    Disabled600: '#A3A3A3',
  },
  neutralBG: {
    BgGrey800: '#1B2333',
    /** (Header) */
    BgGrey700: '#2d3b55',
    BgGrey600: '#424f66',
    BgGrey500: '#576277',
    BgGrey450: '#6c7688',
    BgGrey400: '#818999',
    BgGrey350: '#969daa',
    BgGrey300: '#d5d8dd',
    BgGrey250: '#eaebee',
    BgGrey200: '#f2f3f5',
    BgGrey100: '#f9f9fa',
    BgGrey50: '#fdfdfd',
    BgBlack: '#000000',
    BgWhite: '#FFF',
    BgDisabled: '#E3E3E3',
    BgDelete: '#F7DDDD',
    BgTableCell: '#e8f8f3',
    BgToolTip: '#03060b',
    BgModal: '#576277',
  },
  text: {
    PrimaryHeading: '#040608',
    SectionHeading: '#121822',
    StrongTxt: '#1B2333',
    StandardTxt: '#242f44',
    InputDescription: '#424f66',
    InputMsgDefault: '#576277',
    InputMsgSubText: '#818999',
    TextInputSuggestion: '#969daa',
    InputSuggestion: '#d5d8dd',
    WhiteTxt: '#FFF',
    TxtIssue: '#CA1919',
    TxtDisabled: '#A3A3A3',
    BylineTxt: '#000000',
    BylineHeavy: '#7F818B',
    ReadOnly: 'rgba(0, 0, 0, 0.60)',
  },
  tertiaryTxt: {
    BtnTertiaryDarkHover: '#424F66',
    BtnTertiaryDarkDefault: '#26354A',
    BtnTertiaryDarkClick: '#0E1F36',
  },
  studioBlocks: {
    BlockQuestion: '#00CCBD',
    BlockFunctions: '#EAAB46',
    BlockConnectors: '#857EC9',
    BlocksDocument: '#4676B4',
    BlocksWorkflow: '#000000',
  },
  tags: {
    TagBlackA: '#09131E',
    TagBlackB: '#ECECEC',
    TagGreyA: '#323232',
    TagGreyB: '#d6d6d6',
    TagTealA: '#056368',
    TagTealB: '#DAF4F5',
    TagTealDarkA: '#044855',
    TagTealDarkB: '#C0D1D4',
    TagBlueA: '#0671DF',
    TagBlueB: '#DAEAFA',
    TagRoyalBlueA: '#0014CA',
    TagRoyalBlueBgB: '#DFE3F8',
    TagPurpleA: '#6500CA',
    TagPurpleB: '#E9E1F8',
    TagIrisPurpleA: '#7039FF',
    TagIrisPurpleB: '#EDE6FF',
    TagGreenA: '#00794D',
    TagGreenB: '#DFEEED',
    TagBrownA: '#934E12',
    TagBrownB: '#FDE1C9',
    TagRedA: '#A80000',
    TagRedB: '#FFC9C9',
    TagMustardA: '#CF9400',
    TagMustardB: '#FFEBB8',
  },
  alerts: {
    AlertInfo: '#0777C1',
    AlertSuccess: '#0A855D',
    AlertWarning: '#DB7600',
    AlertIssue: '#A90000',
  },
  links: {
    TextLink: '#2133A1',
  },
  cards: {
    WhiteCard: '#FDFDFD',
  },
  editor: {
    MaterialLabelGrey: '#0000008a',
  },
} as const;
